import React, { useState, useEffect } from "react";
import { useParams, useNavigate } from "react-router-dom";
import {blogs} from "./blogs";

const BlogExt = () => {
  const { id } = useParams();
  const navigate = useNavigate();
  const blog = blogs.find(b => b.id === Number(id));
  
  const [extContent, setExtContent] = useState("");
  const [savedContent, setSavedContent] = useState("");

  // Load saved content from localStorage on component mount
  useEffect(() => {
    const saved = localStorage.getItem(`blog_ext_${id}`);
    if (saved) {
      setExtContent(saved);
      setSavedContent(saved);
    }
  }, [id]);

  if (!blog) {
    return (
      <div style={{ padding: "40px", textAlign: "center" }}>
        <h2>Blog not found</h2>
        <button onClick={() => navigate("/blogs")}>Go Back</button>
      </div>
    );
  }

  const handleSave = () => {
    localStorage.setItem(`blog_ext_${id}`, extContent);
    setSavedContent(extContent);
    alert("EXT content saved successfully!");
  };

  const handleClear = () => {
    setExtContent("");
    localStorage.removeItem(`blog_ext_${id}`);
    setSavedContent("");
  };

  return (
    <div style={{ 
      padding: "40px", 
      backgroundColor: "white",
      minHeight: "100vh"
    }}>
      <div style={{ maxWidth: "900px", margin: "0 auto" }}>
        {/* Header with navigation */}
        <div style={{ 
          display: "flex", 
          justifyContent: "space-between", 
          alignItems: "center",
          marginBottom: "30px",
          paddingBottom: "20px",
          borderBottom: "2px solid #e9ecef"
        }}>
          <div style={{ display: "flex", alignItems: "center", gap: "15px" }}>
            <button 
              onClick={() => navigate(`/blog/${id}`)}
              style={{
                padding: "8px 16px",
                backgroundColor: "#6c757d",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer"
              }}
            >
              ← Back to Blog
            </button>
            <h1 style={{ margin: 0, fontSize: "28px", color: "#333" }}>
              EXT Notes for: {blog.title}
            </h1>
          </div>
        </div>

        {/* Blog Info Card */}
        <div style={{
          display: "flex",
          gap: "20px",
          padding: "20px",
          backgroundColor: "#f8f9fa",
          borderRadius: "10px",
          marginBottom: "30px",
          alignItems: "center"
        }}>
          {blog.image && (
            <img 
              src={blog.image} 
              alt={blog.title}
              style={{
                width: "80px",
                height: "80px",
                borderRadius: "10px",
                objectFit: "cover"
              }}
            />
          )}
          <div>
            <h3 style={{ margin: "0 0 5px 0" }}>{blog.title}</h3>
            <p style={{ margin: 0, color: "#666" }}>
              {blog.date} {blog.author && `• ${blog.author}`}
            </p>
          </div>
        </div>

        {/* EXT Content Section */}
        <div style={{ marginBottom: "20px" }}>
          <h2 style={{ fontSize: "24px", color: "#333", marginBottom: "15px" }}>
            Write EXT Notes
          </h2>
          
          <textarea
            value={extContent}
            onChange={(e) => setExtContent(e.target.value)}
            placeholder="Write your additional notes, thoughts, or any EXT content about this blog post here..."
            style={{
              width: "100%",
              minHeight: "300px",
              padding: "15px",
              fontSize: "16px",
              border: "1px solid #ced4da",
              borderRadius: "8px",
              resize: "vertical",
              fontFamily: "inherit",
              marginBottom: "15px"
            }}
          />

          <div style={{ display: "flex", gap: "10px", justifyContent: "flex-end" }}>
            <button 
              onClick={handleClear}
              style={{
                padding: "10px 20px",
                backgroundColor: "#dc3545",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer"
              }}
            >
              Clear
            </button>
            <button 
              onClick={handleSave}
              style={{
                padding: "10px 20px",
                backgroundColor: "#166534",
                color: "white",
                border: "none",
                borderRadius: "5px",
                cursor: "pointer"
              }}
            >
              Save EXT Notes
            </button>
          </div>
        </div>

        {/* Display Saved Content */}
        {savedContent && (
          <div style={{
            marginTop: "30px",
            padding: "20px",
            backgroundColor: "#f0fdf4",
            borderRadius: "8px",
            border: "1px solid #86efac"
          }}>
            <h3 style={{ margin: "0 0 10px 0", color: "#166534" }}>
              Saved EXT Notes:
            </h3>
            <p style={{ margin: 0, color: "#166534", whiteSpace: "pre-wrap" }}>
              {savedContent}
            </p>
          </div>
        )}
      </div>
    </div>
  );
};

export default BlogExt;